const PREFIX = "becon-b2c-app-web";
// local storage
export const localStorageKeyI18n = `${PREFIX}-i18n`;
export const localStorageKeyToken = `${PREFIX}-token`;
export const localStorageKeyTelemedicine = "medicalReceptionData";
export const localStorageKeyCountryDialCode = `${PREFIX}-country-dial-code`;
export const localStorageKeyLastSignInEmail = `${PREFIX}-last-sign-in-email`;
export const localStorageKeyPurchasedScanner = `${PREFIX}-purchased-b2c-scanner`;
export const localStorageKeyRecentRegion = `${PREFIX}-recent-region`;

// session storage
export const SESSION_STORAGE_KOSSP = "kossp"; // key of sessionStorage Signup Payload
